import { openAppStore } from '@helpers/client'
import { StyleSheet, View } from 'react-native'

import { Button } from '../../components/elements/Button'
import { Text, TextH1 } from '../elements/Text'

export function VersionBlocker() {
  return (
    <View style={styles.container}>
      <TextH1 style={styles.headerText}>Uh Oh!</TextH1>
      <Text>It looks like this version of the app is outdated. Please update to continue using GrownBy.</Text>
      <Button title="Update App" onPress={openAppStore} />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    margin: 20,
    alignSelf: 'center',
    alignItems: 'center',
    maxWidth: 500,
  },
  headerText: {
    textAlign: 'center',
    maxWidth: 400,
  },
})
